import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const FinalCTA = () => {
  return (
    <section id="contact" className="py-24 md:py-32 px-4 bg-gradient-to-br from-blue-500 to-blue-600 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Besoin d'une réparation ?</h2>
        <p className="text-xl mb-8">
          Contactez-nous dès maintenant pour un devis gratuit. Atelier à Saint-Chamond ou intervention à votre adresse.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="tel:0773601521" className="text-2xl font-bold hover:underline">
            07.73.60.15.21
          </a>
          <Link to="/rendez-vous">
            <Button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-lg transition-colors">
              Prendre rendez-vous en ligne
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;